var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156.4 68.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#00b3f0;}.cls-4{fill:#fff;}.cls-5{fill:#153051;}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0.1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 156.4,
    height: 68.8
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DMF_v_TagLine",
    "data-name": "DMF?v_TagLine"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.6,46.7l-19,19h-.1L3.1,36.4v-.1l3.5-3.5h.1L26.5,52.6h.2l1.4-1.4V51L6.8,29.7c-.1-.1-.2-.1-.2,0L0,36.2v.3L32.3,68.8c.1.1.2.1.2,0l22-22c.1-.1.1-.2,0-.2L34.2,26.1a.3.3,0,0,1,0-.4A15.84,15.84,0,0,0,28.7,1.2c-3.6-1.8-9.6-1.7-13.2.1A15.93,15.93,0,0,0,11,26.8L36.8,52.6H37l1.4-1.4V51L12.3,25A12.83,12.83,0,0,1,9.4,11,13.64,13.64,0,0,1,31.7,6.1a13.51,13.51,0,0,1,.9,18.1.3.3,0,0,1-.4,0l-10-10c-.1-.1-.2-.1-.2,0L16.3,20v.2l1.4,1.4h.2l4.3-4.3h.1L51.7,46.7h-.1",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.7,12a8.79,8.79,0,0,1-2.3,6.2A8.45,8.45,0,0,1,68,20.6H60.3V19.3h2.3V4.7H60.3V3.4H68a8.37,8.37,0,0,1,6.5,2.5A8.93,8.93,0,0,1,76.7,12m-1.6,0a7.48,7.48,0,0,0-1.8-5.2c-1.2-1.4-3-2-5.3-2H64V19.4h3.9a6.93,6.93,0,0,0,5.3-2A7.76,7.76,0,0,0,75.1,12",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M94.8,20.6H88.9V19.2h2.5L90,15.5H82.2l-1.5,3.7h2.7v1.4H77.5V19.2h1.6L84.9,4.7H82.1V3.4h4.6l6.2,15.9h1.7v1.3Zm-5.2-6.3L86.3,5.6h-.1l-3.4,8.7Z",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "113.5 4.8 111.3 4.8 111.3 20.7 110.3 20.7 100.1 6.5 100 6.5 100 19.4 102.8 19.4 102.8 20.7 96.5 20.7 96.5 19.4 98.5 19.4 98.5 4.8 96.2 4.8 96.2 3.5 99.7 3.5 109.8 17.6 109.9 17.6 109.9 4.8 107.2 4.8 107.2 3.5 113.5 3.5 113.5 4.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.8,15.9a4.39,4.39,0,0,1-1.7,3.7,7.46,7.46,0,0,1-4.2,1.3,10.12,10.12,0,0,1-3.1-.4,7.68,7.68,0,0,1-2.2-.9l.3-3.2,1.2.1-.1,2.2a6.36,6.36,0,0,0,1.8.6,12.31,12.31,0,0,0,2,.2,6.21,6.21,0,0,0,3.1-.8,2.79,2.79,0,0,0,1.3-2.7,2.66,2.66,0,0,0-1.4-2.7,16,16,0,0,0-3.1-1,21.72,21.72,0,0,1-2.4-.7,5.33,5.33,0,0,1-2-1.3,3.74,3.74,0,0,1-.8-2.5A4.26,4.26,0,0,1,118,4.3a5.86,5.86,0,0,1,3.7-1.2,9,9,0,0,1,2.8.4,8.47,8.47,0,0,1,2.3.9l.2,3.3-1.2.1-.3-2.7a5.78,5.78,0,0,0-1.7-.6,10.28,10.28,0,0,0-1.7-.1,4.65,4.65,0,0,0-2.8.8,2.71,2.71,0,0,0-1.1,2.3,2.19,2.19,0,0,0,1.3,2.3,23.07,23.07,0,0,0,2.8,1c.8.2,1.6.4,2.5.7a5.55,5.55,0,0,1,2.2,1.4,5.33,5.33,0,0,1,.8,3",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "146.1 20.7 140.3 20.7 140.3 19.4 142.4 19.4 137.5 12.6 134.4 12.6 134.4 19.4 136.6 19.4 136.6 20.7 130.7 20.7 130.7 19.4 132.9 19.4 132.9 4.8 130.7 4.8 130.7 3.5 136.6 3.5 136.6 4.8 134.4 4.8 134.4 11.3 137.4 11.3 142.2 4.8 140 4.8 140 3.5 145.8 3.5 145.8 4.8 143.8 4.8 138.7 11.8 144.2 19.4 146.1 19.4 146.1 20.7"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "81.3 27.6 78.9 27.6 78.9 42.2 81.2 42.2 81.2 43.5 75.3 43.5 75.3 42.2 77.4 42.2 77.4 30 77.3 30 71.2 42.8 70.3 42.8 64.1 30 64 30 64 42.2 66.2 42.2 66.2 43.5 60.3 43.5 60.3 42.2 62.5 42.2 62.5 27.6 60.2 27.6 60.2 26.3 63.9 26.3 70.8 40.5 70.9 40.5 77.6 26.3 81.3 26.3 81.3 27.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100.8,34.8a10,10,0,0,1-1.1,4.5,8.51,8.51,0,0,1-15,0,9.36,9.36,0,0,1-1.1-4.5,10,10,0,0,1,1.1-4.5,8.45,8.45,0,0,1,14.9,0,8,8,0,0,1,1.2,4.5m-1.6,0a7.93,7.93,0,0,0-1.9-5.4,6.71,6.71,0,0,0-5.1-2.2,6.39,6.39,0,0,0-5.1,2.2,8.18,8.18,0,0,0-1.9,5.3A7.85,7.85,0,0,0,87.1,40a6.12,6.12,0,0,0,5.1,2.2A6.39,6.39,0,0,0,97.3,40a7.1,7.1,0,0,0,1.9-5.2",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "118 31.4 116.6 31.5 116.1 27.6 111.2 27.6 111.2 42.2 114.3 42.2 114.3 43.5 106.7 43.5 106.7 42.2 109.7 42.2 109.7 27.6 104.8 27.6 104.3 31.5 102.9 31.4 103.4 26.3 117.5 26.3 118 31.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.3,34.8a10,10,0,0,1-1.1,4.5,8.51,8.51,0,0,1-15,0,9.36,9.36,0,0,1-1.1-4.5,10,10,0,0,1,1.1-4.5,8.45,8.45,0,0,1,14.9,0,8.92,8.92,0,0,1,1.2,4.5m-1.7,0a7.93,7.93,0,0,0-1.9-5.4,6.71,6.71,0,0,0-5.1-2.2,6.39,6.39,0,0,0-5.1,2.2,8.18,8.18,0,0,0-1.9,5.3,7.85,7.85,0,0,0,1.9,5.3,6.12,6.12,0,0,0,5.1,2.2,6.39,6.39,0,0,0,5.1-2.2,7.1,7.1,0,0,0,1.9-5.2",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.5,43.4h-3.2L147.5,36h-4.1v6h2.4v1.4h-6.2V42h2.3V27.5h-2.3V26.1h7.3a6.21,6.21,0,0,1,4.5,1.4,4.67,4.67,0,0,1,1.3,3.4,5.29,5.29,0,0,1-.9,3,4.57,4.57,0,0,1-2.9,1.8l3.3,6.3h2.2v1.4ZM151.3,31a3,3,0,0,0-1-2.6,5,5,0,0,0-3.3-.9h-3.4v7.2h3.5a4.5,4.5,0,0,0,3.3-1,4.15,4.15,0,0,0,.9-2.7",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73.5 54.2 71 54.5 70.5 51.6 65.1 51.6 65.1 57.1 72.6 57.1 72.6 59.6 65.1 59.6 65.1 63.8 68 63.8 68 66.3 60.2 66.3 60.2 63.8 62.2 63.8 62.2 51.6 60.2 51.6 60.2 49.1 73 49.1 73.5 54.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "82.6 66.3 75.7 66.3 75.7 63.8 77.7 63.8 77.7 51.6 75.7 51.6 75.7 49.1 82.6 49.1 82.6 51.6 80.6 51.6 80.6 63.8 82.6 63.8 82.6 66.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "103.4 51.6 101.4 51.6 101.4 66.3 99.7 66.3 90.1 54.4 90 54.4 90 63.8 92.5 63.8 92.5 66.3 85.4 66.3 85.4 63.8 87.3 63.8 87.3 51.6 85.1 51.6 85.1 49.1 89.4 49.1 98.5 60.5 98.6 60.5 98.6 51.6 96.1 51.6 96.1 49.1 103.4 49.1 103.4 51.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M121.9,66.2h-6.6V63.7h1.8l-.9-2.4h-6.4l-.9,2.4h1.9v2.5h-6.5V63.7h1.6l5.2-12.2h-2.5V49h5.5l6.2,14.7H122v2.5Zm-6.5-7-2.3-6H113l-2.4,6Z",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "141.5 51.6 139.5 51.6 139.5 66.3 137.8 66.3 128.3 54.4 128.2 54.4 128.2 63.8 130.7 63.8 130.7 66.3 123.5 66.3 123.5 63.8 125.4 63.8 125.4 51.6 123.2 51.6 123.2 49.1 127.6 49.1 136.7 60.5 136.8 60.5 136.8 51.6 134.3 51.6 134.3 49.1 141.5 49.1 141.5 51.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156.4,61.1a4.9,4.9,0,0,1-1.8,4,7.72,7.72,0,0,1-4.7,1.4,12.67,12.67,0,0,1-3.4-.4,7,7,0,0,1-2.6-1.2l.5-4,2.4.2-.1,2.1a6.39,6.39,0,0,0,1.6.6,6.6,6.6,0,0,0,1.4.1,6.69,6.69,0,0,0,2.6-.5c.7-.3,1-1,1-2a2.2,2.2,0,0,0-1.2-2.2,10.67,10.67,0,0,0-2.7-.8c-.8-.2-1.6-.4-2.5-.6a5.71,5.71,0,0,1-2.1-1.3,4.14,4.14,0,0,1-.8-2.7,4.34,4.34,0,0,1,1.8-3.9,7.3,7.3,0,0,1,4.1-1.2,10.59,10.59,0,0,1,3.1.5,5.51,5.51,0,0,1,2.3,1.2l.2,3.6-2.4.2L153,52a4.71,4.71,0,0,0-1.5-.6,7.84,7.84,0,0,0-1.4-.2,4.65,4.65,0,0,0-2.1.5,1.82,1.82,0,0,0-.8,1.6,1.73,1.73,0,0,0,1,1.8,12.34,12.34,0,0,0,2.3.8c.7.2,1.5.4,2.5.6a5.85,5.85,0,0,1,2.4,1.4,4.55,4.55,0,0,1,1,3.2",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "73.5 54.2 71 54.5 70.5 51.6 65.1 51.6 65.1 57.1 72.6 57.1 72.6 59.6 65.1 59.6 65.1 63.8 68 63.8 68 66.3 60.2 66.3 60.2 63.8 62.2 63.8 62.2 51.6 60.2 51.6 60.2 49.1 73 49.1 73.5 54.2"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "82.6 66.3 75.7 66.3 75.7 63.8 77.7 63.8 77.7 51.6 75.7 51.6 75.7 49.1 82.6 49.1 82.6 51.6 80.6 51.6 80.6 63.8 82.6 63.8 82.6 66.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "103.4 51.6 101.4 51.6 101.4 66.3 99.7 66.3 90.1 54.4 90 54.4 90 63.8 92.5 63.8 92.5 66.3 85.4 66.3 85.4 63.8 87.3 63.8 87.3 51.6 85.1 51.6 85.1 49.1 89.4 49.1 98.5 60.5 98.6 60.5 98.6 51.6 96.1 51.6 96.1 49.1 103.4 49.1 103.4 51.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.9,66.2h-6.6V63.7h1.8l-.9-2.4h-6.4l-.9,2.4h1.9v2.5h-6.5V63.7h1.6l5.2-12.2h-2.5V49h5.5l6.2,14.7H122v2.5Zm-6.5-7-2.3-6H113l-2.4,6Z",
    transform: "translate(0 0.1)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "141.5 51.6 139.5 51.6 139.5 66.3 137.8 66.3 128.3 54.4 128.2 54.4 128.2 63.8 130.7 63.8 130.7 66.3 123.5 66.3 123.5 63.8 125.4 63.8 125.4 51.6 123.2 51.6 123.2 49.1 127.6 49.1 136.7 60.5 136.8 60.5 136.8 51.6 134.3 51.6 134.3 49.1 141.5 49.1 141.5 51.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.4,61.1a4.9,4.9,0,0,1-1.8,4,7.72,7.72,0,0,1-4.7,1.4,12.67,12.67,0,0,1-3.4-.4,7,7,0,0,1-2.6-1.2l.5-4,2.4.2-.1,2.1a6.39,6.39,0,0,0,1.6.6,6.6,6.6,0,0,0,1.4.1,6.69,6.69,0,0,0,2.6-.5c.7-.3,1-1,1-2a2.2,2.2,0,0,0-1.2-2.2,10.67,10.67,0,0,0-2.7-.8c-.8-.2-1.6-.4-2.5-.6a5.71,5.71,0,0,1-2.1-1.3,4.14,4.14,0,0,1-.8-2.7,4.34,4.34,0,0,1,1.8-3.9,7.3,7.3,0,0,1,4.1-1.2,10.59,10.59,0,0,1,3.1.5,5.51,5.51,0,0,1,2.3,1.2l.2,3.6-2.4.2L153,52a4.71,4.71,0,0,0-1.5-.6,7.84,7.84,0,0,0-1.4-.2,4.65,4.65,0,0,0-2.1.5,1.82,1.82,0,0,0-.8,1.6,1.73,1.73,0,0,0,1,1.8,12.34,12.34,0,0,0,2.3.8c.7.2,1.5.4,2.5.6a5.85,5.85,0,0,1,2.4,1.4,4.55,4.55,0,0,1,1,3.2",
    transform: "translate(0 0.1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bc10596f.svg";
export { ForwardRef as ReactComponent };